import React, { useEffect, useState } from 'react';
import './index.scss';
import { MODAL_ENTITY, showError } from 'utils';
import _ from 'lodash';
import OrderTableModal from 'components/OrderTableModal';
import ItemsTableModal from 'components/ItemsTableModal';

interface IDashboarditems {
  itemHeaderName: any; 
  apiFunction?: any | (() => Promise<any>);
  isActionModal: boolean; 
  isActionRoute: boolean; 
  history: any;
  route: string; 
  refresh: boolean; 
  color: string; 
  modalEntity: string;
}
function DashboardItem(props: IDashboarditems ): JSX.Element {
  const { itemHeaderName, apiFunction, isActionModal, isActionRoute, route, refresh, color, modalEntity } = props;
  const [items, setItems] = useState<any>([]);
  const [itemMetric, setItemMetric] = useState<any>('N/A');
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState('');

  useEffect(() => {
    handleAPIFunctionCall();
  }, [apiFunction, refresh]);

  const handleAPIFunctionCall = async () => {
    setLoading(true);
    try {
      if (apiFunction) {
        const response = await apiFunction();
        if (!_.isArray(response)) {
          setItemMetric(response);
        } else {
          setItems(response);
          setItemMetric(response.length);
        }
      }
    } catch (e) {
      showError(e);
    } finally {
      setLoading(false);
    }
  };

  function handleItemDetailsClick() {
    if (isActionModal) {
      switch (modalEntity) {
      case MODAL_ENTITY.ITEMS:
        setShowModal(MODAL_ENTITY.ITEMS);
        break;
      case MODAL_ENTITY.ORDERS:
        setShowModal(MODAL_ENTITY.ORDERS);
        break;
      default:
        break;
      }
    }
    if (isActionRoute) {
      props.history.push(route);
    }
  }

  return (
    <div className="col-xl-2 col-lg-3 col-6">
      <div className={`small-box bg-${color}-gradient`}>
        <div className="inner">
          <h3>{itemMetric}</h3>
          <p>{itemHeaderName}</p>
        </div>
        <div className="small-box-footer">
          <a className="no-href-custom" id="details" aria-disabled={loading} onClick={handleItemDetailsClick}>Details {' '}
            <i className="fa fa-arrow-circle-right"></i>
          </a>
          {!loading ?  <a className="no-href-custom" id="refresh" onClick={handleAPIFunctionCall}>Refresh {' '}
            <i className="fa fa-refresh"></i>
          </a> : 'Loading...'}
         
        </div>
      </div>
      {showModal === MODAL_ENTITY.ORDERS && <OrderTableModal data={items} toggleModal={() => setShowModal('')} />}
      {showModal === MODAL_ENTITY.ITEMS && <ItemsTableModal data={items} toggleModal={() => setShowModal('')} />}
    </div>
  );
}

export default DashboardItem;